export default "__VITE_ASSET__e44091b0__"